module.exports = __webpack_public_path__ + "static/img/electron1.565a236.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/electron1.png
// module id = u3Yt
// module chunks = 3